export default { sha: 'fea63529d83416f7e24413748c023d7f7cb03cac', buildNumber: 'undefined' }
